// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Webapi__Dom__HtmlImageElement from "../../../../node_modules/rescript-webapi/lib/es6_global/src/Webapi/Dom/Webapi__Dom__HtmlImageElement.bs.js";
function useImageSize(url) {
  var match = React.useState(function () {
    return [0, 0];
  });
  var setSize = match[1];
  React.useEffect(function () {
    var handleLoad = function ($$event) {
      var target = Curry._1(Webapi__Dom__HtmlImageElement.ofElement, $$event.target);
      var naturalHeight = Belt_Option.mapWithDefault(target, 0, function (prim) {
        return prim.naturalHeight;
      });
      var naturalWidth = Belt_Option.mapWithDefault(target, 0, function (prim) {
        return prim.naturalWidth;
      });
      Curry._1(setSize, function (param) {
        return [naturalWidth, naturalHeight];
      });
    };
    var img;
    if (url === "") {
      img = undefined;
    } else {
      var img$1 = document.createElement("img");
      img$1.addEventListener("load", handleLoad);
      img$1.setAttribute("src", url);
      img = Caml_option.some(img$1);
    }
    return function (param) {
      Belt_Option.forEach(img, function (__x) {
        __x.removeEventListener("load", handleLoad);
      });
    };
  }, [url]);
  return match[0];
}
export { useImageSize };
/* react Not a pure module */